import styles from "../../scss/common/cartItemChangeNote.module.scss";

type Props = {
  changes: string[];
  unavailable?: boolean;
  onAccept?: () => void;
  onRemove: () => void;
};

const CartItemChangeNote = ({
  changes,
  unavailable = false,
  onAccept,
  onRemove,
}: Props) => {
  if (!changes?.length && !unavailable) return null;

  return (
    <div className={styles.note}>
      <p style={{ color: "red", marginLeft: "5px" }}>This Item has been changed</p>
      <div className={styles.actions}>
        {!unavailable && onAccept ? (
          <button type="button" className={styles.approveButtons} onClick={onAccept}>
            Accept Changes
          </button>
        ) : null}
        <button type="button" className={styles.approveButtons} onClick={onRemove}>
          Remove Item
        </button>
      </div>
    </div>
  );
};

export default CartItemChangeNote;
